// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lilligant_hisui: PokeData = {
  "id": 10237,
  "name": "lilligant-hisui",
  "height": 12,
  "weight": 192,
  "base_experience": 168,
  "types": [
    PokeType.GRASS,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "mega-kick",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "petal-dance",
    "recover",
    "giga-drain",
    "synthesis",
    "sunny-day",
    "rock-smash",
    "helping-hand",
    "teeter-dance",
    "magical-leaf",
    "leaf-blade",
    "close-combat",
    "drain-punch",
    "energy-ball",
    "defog",
    "leaf-storm",
    "entrainment",
    "after-you",
    "petal-blizzard",
    "solar-blade",
    "leafage",
    "victory-dance",
    "axe-kick"
  ],
  "moves": [
    "poison-powder",
    "stun-spore",
    "synthesis",
    "sunny-day",
    "rock-smash",
    "close-combat",
    "drain-punch",
    "energy-ball",
    "karate-chop",
    "flower-rush",
    "overgrowth",
    "aromatherapy",
    "double-kick"
  ],
  "evolution_chain": {
    "id": 279,
    "item": null,
    "species": [
      {
        "name": "petilil",
        "order": 549,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lilligant",
        "order": 550,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 548,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 149,
    "ability_power": 149
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
